import { render, staticRenderFns } from "./TrafficMonitoringView.vue?vue&type=template&id=3b4f394c&"
import script from "./TrafficMonitoringView.vue?vue&type=script&lang=js&"
export * from "./TrafficMonitoringView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports